module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAgVBMVEUAAAAA//8kktszgOYniesiiN0gj98khucpheAqiOUoh98liOIoiuMoiuEniOImieInieMoieEnieIniuEnieEniOMnieMniuEnieEnieMniuInieEniuInieIniuInieInieImieInieInieInieInieInieInieInieInieInieK0ihB+AAAAKnRSTlMAAQcKDQ8QFRkeID4/TE9QW19ob3B2iImKoqW+v8vM0dPU4+X09fb4/P4hiOs7AAAAnklEQVRIx+2URw7CUAxEh2p66D3FEErm/gdkFQkRgjIrkMhbfs+Tv70wUPNjDLbxhaUU87OUnyjkJxn3o05eeA28EcjVU6GS0FQF/LFgYWiKYE66CYLTnS4IdDOn0sEAq97hEBkAWHSsKJRRC/lTY5nchCNAbrSrQd5P0670pXNPnGGsDt3ShJgLTQiybDdsCwLmV22tQH+dpJJQ80UeVIU7XNGzgDkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/course/shiti@2x.png
// module id = Z5fp
// module chunks = 0